import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';

import { StorageService } from './storage.service';
import { EnvironmentService } from './environment.service';
import { Observable } from 'rxjs';
import { LoggerService } from './logger.service';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class HttpService {

  private headers: any;
  constructor(
    private http: Http,
    private storageService: StorageService,
    private envService: EnvironmentService,
    private loggerService: LoggerService,
    private router: Router
  ) {
    this.headers = new Headers();
    this.headers.set('Content-Type', 'application/json');
  }

  // To set Application spectific and Webservice call specific Headers
  private setHeaders(customHeaders?: any): Headers {

    // Setting API Configuration and Authentication Headers
    const accessToken = this.storageService.getLocalItem('access_token');
    if (accessToken) {
      this.headers.set('Authorization', 'Bearer ' + accessToken);
      // this.headers.append('Access-Control-Allow-Origin', '*');
    }
    this.headers.set('X-Api-Key', this.envService.get('xApiKey'));

    // Setting custom Headers
    if (customHeaders) {
      customHeaders.forEach((header, index) => {
        this.headers.set(index, header);
      });
    }
    return this.headers;
  }

  // To set Environment specific API Location
  private getAbsoluteUrl(url: string) {
    if (url.indexOf('http') === -1) {
      return this.envService.get('apiEndpoint') + url ;
    }
    return url;
  }

  // To initiate request upon given url
  private request(
    methodType: string,  url: string,
    payload?: any, headers?: any,
    noRedirect: boolean = false
  ): Observable<any> {
    let response: Observable<any> = null;

    // Set Request Parameters
    url = this.getAbsoluteUrl(url);
    const options = {
      headers: this.setHeaders(headers),
      method: methodType,
      body: payload
    };

      // Initiate API Call
      response = this.http.request(url, options).map(
        (data: Response) => {
          return data.json();
        }
      ).catch(
        (error) =>  {
          switch (error.status) {
            case 0:
              this.router.navigate(['/restrict/sessionExpired']);
              break;
            case 401:
            case 403:
            case 500:
              if(!noRedirect)
                {
                  this.router.navigate(['/restrict/unauthorized']);
                }
              break;
          }
          return Observable.throw(error);
        }
      );

    // return back the response
    return response;
  }

  // To invoke GET Method API call
  public get(url: string, payload?: any, noRedirect?: boolean): Observable<any> {
    return this.request('GET', url, payload,[],noRedirect);
  }

  // To invoke POST Method API call
  public post(url: string, payload: any): Observable<any> {
    return this.request('POST', url, payload);
  }

  // To invoke DELETE Method API call
  public delete(url: string): Observable<any> {
    const headers = this.setHeaders();
    url = this.getAbsoluteUrl(url);
    const options = {
      headers: this.setHeaders(headers),
      method: 'DELETE'
    };
    return this.http.request(url, options);
  }
}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/services/http.service.ts